// Formatea un código GL como "código — nombre" (ej. "2030-00 — MISCELLANEOUS EXPENSES").
// Fallback: si no hay nombre para el código, devuelve el código crudo (nunca vacío, nunca rompe).
//
// `nameOrGlCodes` puede ser:
//   (a) un array de OptionsContext.glCodes / gl-accounts  → [{ code, name, ... }, ...]
//   (b) un mapa { code: name }
//   (c) un nombre ya resuelto por el backend (string, ej. entry.gl_code_name)
export function formatGlLabel(code, nameOrGlCodes) {
  if (!code) return '';
  let name = null;
  if (typeof nameOrGlCodes === 'string') {
    name = nameOrGlCodes;                                     // backend ya resolvió el nombre
  } else if (Array.isArray(nameOrGlCodes)) {
    name = nameOrGlCodes.find(g => g.code === code)?.name || null;
  } else if (nameOrGlCodes && typeof nameOrGlCodes === 'object') {
    name = nameOrGlCodes[code] || null;                       // mapa { code: name }
  }
  return name ? `${code} — ${name}` : code;                   // fallback: solo código
}
